{
  "title": "AURA Agents",
  "descriptionText": "Register and manage the AURA runtime agents connected to this account. Each agent gets its own service account and access key. Learn more about",
  "descriptionLinkText": "Mezmo AURA",
  "registerNew": "Register Agent",
  "backToList": "Back to Agents",
  "noDataTitle": "No Agents Registered Yet",
  "noDataMessage": "Click “Register Agent” above to register your first runtime agent.",
  "deleteConfirmTitle": "Delete {{name}}?",
  "deleteConfirmBody": "The agent will be unregistered. This cannot be undone.",
  "deleteServiceAccountLabel": "Also delete the service account (and its access key) associated with this agent",
  "table": {
    "name": "Name",
    "policy": "Policy",
    "noPolicy": "None",
    "instanceId": "Instance ID",
    "status": "Status",
    "registered": "Registered"
  },
  "form": {
    "nameLabel": "Agent Name",
    "nameHelp": "A user-friendly name for the registered agent, e.g. \"Aura Investigator Agent\". Letters, numbers, spaces, and _ . - only.",
    "nameRequired": "Agent name is required.",
    "nameMinLength": "Agent name must be at least {{length}} characters.",
    "nameInvalidCharacters": "Agent name may only contain letters, numbers, single spaces, and _ . -",
    "instanceIdLabel": "Instance ID",
    "instanceIdHelp": "A unique identifier for the running agent instance, e.g. \"aura-instance-ab12cd34\"",
    "instanceIdRequired": "Instance ID is required.",
    "instanceIdConflict": "An agent with this instance ID is already registered. Enter a different instance ID.",
    "descriptionLabel": "Description",
    "descriptionHelp": "Optional additional details about the agent.",
    "saveFailed": "An error occurred while trying to register the agent. Please try again.",
    "updateFailed": "An error occurred while trying to update the agent. Please try again.",
    "submit": "Register Agent"
  },
  "wizard": {
    "continue": "Continue",
    "steps": {
      "details": "Details",
      "serviceAccount": "Service Account",
      "policy": "Policy",
      "finished": "Finished"
    },
    "stepHints": {
      "details": "Name and instance",
      "serviceAccount": "Select or create",
      "policyOptional": "Assign governance policy",
      "finishedRegister": "Access key & config",
      "finishedEdit": "Agent config"
    },
    "blocker": {
      "details": "Fix the highlighted fields to continue",
      "serviceAccount": "Select a service account to continue"
    },
    "details": {
      "step": "Step 1",
      "title": "Describe this agent",
      "description": "The instance ID identifies where this agent runs. Next you will choose the service account the agent authenticates as.",
      "editTitle": "Edit this agent",
      "editDescription": "Update the details of this registered agent."
    },
    "serviceAccount": {
      "step": "Step 2",
      "title": "Choose a service account",
      "description": "The agent authenticates with this service account's access key, and the account's roles and permissions decide what the agent may do.",
      "selectLabel": "Service Account",
      "selectHelp": "Select an existing service account for this agent, or create a new one. Each service account has its own access key.",
      "placeholder": "Select a service account",
      "create": "Create Service Account",
      "empty": "No service accounts yet. Create one to continue.",
      "listUnavailable": "You do not have permission to list existing service accounts, but you can create a new one for this agent.",
      "noAccess": {
        "title": "Insufficient Permissions",
        "message": "You do not have the required permissions to view or create service accounts. Ask an account admin to grant you access to service accounts."
      },
      "info": {
        "idLabel": "Service Account ID",
        "keyLabel": "Access Key",
        "keyTrailer": "Ending in {{trailer}}",
        "keyUnknown": "Unknown",
        "createdLabel": "Created"
      }
    },
    "policy": {
      "step": "Step 3",
      "title": "Assign a governance policy",
      "description": "The assigned policy decides, for every tool call this agent makes, whether it runs, waits for a person, or is refused.",
      "selectLabel": "Policy",
      "selectHelp": "Every tool call from this agent is evaluated against the assigned policy. You can change it at any time.",
      "noneOption": "No policy (assign later)",
      "viewPolicy": "View policy",
      "viewPolicyNewTab": "Opens in a new tab so your progress here is kept.",
      "info": {
        "descriptionLabel": "Description",
        "descriptionEmpty": "No description",
        "defaultActionLabel": "Fallthrough",
        "rulesLabel": "Rules",
        "oneRule": "1 rule",
        "ruleCount": "{{count}} rules",
        "createdLabel": "Created"
      },
      "empty": {
        "title": "No Policies Yet",
        "message": "You can continue without one — but this agent will be ungoverned until you create a policy and assign it from the Edit Agent page.",
        "createLink": "Create a policy"
      }
    },
    "finished": {
      "step": "Step 4",
      "titleSaved": "Agent Saved",
      "savedMessage": "{{name}} has been updated.",
      "configTitle": "Connect the agent to AURA",
      "configDescription": "Add this to your AURA agent's configuration so its actions are routed to this account for approval."
    }
  },
  "accessKey": {
    "title": "Agent Registered",
    "message": "{{name}} has been registered and linked to its service account.",
    "warning": "Copy the access key below and store it somewhere safe. This is the only time it will be displayed and it cannot be retrieved again.",
    "label": "Access Key",
    "copy": "Copy access key",
    "copied": "Copied!",
    "agentId": "Agent ID",
    "serviceAccountId": "Service Account ID",
    "done": "Go to Agents",
    "existingAccountNote": "This agent uses an existing service account. Its access key was shown once when that account was created and cannot be retrieved again."
  }
}
